// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ifSx","left":"styles_left__1Xwrp","right":"styles_right__16sJN","alert":"styles_alert__1-LGa"};